<template>
	<div v-loading="dataLoading">
		<tab name="3">{{id}} {{formData && formData.activityName}} <b v-if="formData && formData.haveEditAudit"
				class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
		<el-form v-if="formData" :model="formData" ref="formData" label-position="top"
			:disabled="formData && formData.haveEditAudit">
			<div class="fl" style="position: relative; z-index: 100;">
				<el-dropdown @command="handleCommand">
					<el-button type="primary">
						展开场次<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item, index) in formData.sessions" :command="index">
							{{ item.id ? '场次'+(index+1)+'(ID:'+item.id+')' + ( item.name ) : '场次'+ +(index+1) + ( item.name ) }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<el-tabs v-model="tabName" type="card" @tab-remove="removeSessions" :before-leave="beforeLeave">
				<el-tab-pane v-for="(item, index) in formData.sessions" :key="index"
					:label="item.id ? '场次'+(index+1)+'(ID:'+item.id+')' : `场次${index+1}`" :name="index.toString()"
					:closable="item.id || index == 0 ? false : true">
					<el-card class="sessions-card">
						<!-- <div slot="header" class="clearfix">
                            <h2 class="fl">场次{{index+1}} {{item.id ? `(ID:${item.id})` : ''}}</h2>
                            <el-button v-if="!item.id" icon="el-icon-delete" type="text" class="fr" size="mini" @click="delOs(index)">删除</el-button>
                        </div> -->
						<div v-if="!item.status" class="page-group-title">
							<span class="color-danger"><i class="el-icon-warning"></i> 当前场次已取消</span>
						</div>
						<el-row :gutter="0">
							<el-col :xs="24" :sm="12" :xl="8">								
								<el-form-item :prop="`sessions[${index}].startTime`"
									:rules="[{required: true, message: `请选择场次${index+1}的演出开始时间`}]" >
									<span slot="label">
										演出开始时间:	
										<span class="ML10">
											<el-checkbox v-model="item.isConfirmedStartTime" :true-label="0"
											:false-label="1">时间待定</el-checkbox>
											<el-checkbox v-model="item.isDelay" :true-label="1"
											:false-label="0">场次延期</el-checkbox>
										</span>
									</span>									
									<el-date-picker v-model="item.startTime" type="datetime" placeholder="演出开始时间"
										value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
										default-time="20:30:00" size="medium" @change="timeChange(index)"></el-date-picker>
								</el-form-item>
								<div v-if="item.durationText" class="MB20">
									<p v-html="item.durationText"></p>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].endTime`"
									:rules="[{required: true, message: `请选择场次${index+1}的演出结束时间`}]" >	
									<span slot="label">演出结束时间:</span>		
									<el-date-picker v-model="item.endTime" type="datetime" placeholder="演出结束时间"
										value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
										default-time="22:00:00" size="medium" @change="timeChange(index)"></el-date-picker>
								</el-form-item>	
							</el-col>							
						</el-row>						
						<el-row :gutter="30">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].name`"
									:rules="[{required: true, message: `请输入场次${index+1}的场次名称`}]">
									<span slot="label">场次名称: <small class="MR20"><i
												class="color-danger">建议使用开演日期+时间作为场次名称，增加用户辨识度</i></small>
												<el-button size="small" type="text" @click="updateName(index)">按开场时间</el-button>
									</span>
									<el-input v-model="item.name" placeholder="请输入场次名称" size="medium"
										maxlength="35" @change="nameChange(index)"></el-input>
									<div v-if="item.sessionNameMark && item.sessionNameMark != ''">
										<p v-html="item.sessionNameMark"></p>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="30">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].performers`">
									<div slot="label">
										艺人阵容:
										<el-checkbox v-model="item.isSyncPerformers" :true-label="1"
											:false-label="0" @change="syncPerformers($event,index)">同步同步艺人阵容到演出下其他所有场次</el-checkbox>
										<span class="ML10">
											<el-button size="mini" type="text" @click="addArtist(index,1)" >
												点击创建艺人
											</el-button>
										</span>
									</div>
									<el-select v-model="item.performers" filterable remote multiple placeholder="请选择艺人"
										:remote-method="searchArtist" :loading="userLoading" size="medium"
										@change="updateUser(index)" @focus="onFocus(index)" value-key="id">
										<el-option v-for="a in item.artistList" :key="a.id" :label="a.name" :value="a">
										</el-option>
									</el-select>
									<div v-if="item.customPerformers">
										用户自定义艺人阵容: 
										<el-tag v-for="(a,i) in item.customPerformers" :key="i" type="info" size="mini" closable @close="removePerformer(index,i)" @click="addArtist(index, 1, a)"  class="ML10">{{a.name}}</el-tag>
									</div>

								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="30">
							<el-col :xs="24" :xl="24">
								<el-form-item>
									<span slot="label">出场顺序及表演时间段:
										<small class="MR20">
											<div class="color-danger">设置后会在app推送通知，建议有多个艺人出演时设置</div>
										</small>
										<el-button type="text" size="mini" @click="clearTime(index)"
											v-if="item.setTime">清除艺人出场时段</el-button>
										<el-button type="text" size="mini" @click="timeshow(index)"
											v-else>创建艺人出场时段</el-button>
									</span>
									<div class="optionsListMain MB20" v-if="item.setTime">
										<div v-for="(items, indexs) in item.performersTime" class="optionsList MT10"
											:key="indexs">
											<el-row :gutter="10" type="flex" justify="flex-start">
												<el-col :span="4">
													<el-tag type="info">{{items.name}}</el-tag>
												</el-col>
												<el-col :span="14">
													<el-date-picker v-model="items.datetimerangeUser"
														type="datetimerange" range-separator="至"
														value-format="yyyy-MM-dd HH:mm:ss"
														:default-time="['00:00:00', '23:59:59']"
														start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels
														size="small" style="width: 400px;">
													</el-date-picker>

												</el-col>
											</el-row>
										</div>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="30">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].lineupNature`">
									<span slot="label">
										阵容性质:
									</span>
									<el-radio-group v-model="item.lineupNature" size="medium" @change="changeLineupNature(index, $event)">
										<el-radio :label="1">单人专场</el-radio>
										<el-radio :label="2">多人拼盘</el-radio>
									</el-radio-group>
									<small v-if="item.lineupNature == 1"><i
											class="color-danger">对于除了主演艺人外，只有嘉宾或暖场艺人的演出，应该也视为【单人专场】</i></small>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].guests`">
									<span slot="label">
										嘉宾阵容:
										<el-button size="mini" type="text" @click="addArtist(index,2)">
											点击创建嘉宾
										</el-button>
									</span>
									<el-select v-model="item.guests" filterable remote multiple placeholder="请选择嘉宾"
										:remote-method="searchGuests" :loading="userLoading" size="medium"
										@focus="onFocus(index)" value-key="id">
										<el-option v-for="a in item.guestsList" :key="a.id" :label="a.name" :value="a">
										</el-option>
									</el-select>
									<div v-if="item.customGuests">
										用户自定义嘉宾阵容: 
										<el-tag v-for="(a,i) in item.customGuests" :key="i" type="info" size="mini" closable @close="removeGuest(index,i)" @click="addArtist(index, 2, a)"  class="ML10">{{a.name}}</el-tag>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="30"
							v-if="formData.sessions[index].sellMode == 3 && formData.sessions[index].activityChannel && formData.sessions[index].activityChanne !=''">
							<el-col :span="12">
								<el-form-item :prop="`sessions[${index}].showSeat`">
									<span slot="label">
										座位号展示逻辑:
									</span>
									<el-radio-group v-model="item.showSeat" size="medium">
										<el-radio :label="1">立刻展示</el-radio>
										<el-radio :label="2">指定时间展示</el-radio>
									</el-radio-group>
									<span v-if="item.showSeat == 2">
										<el-date-picker v-model="item.seatShowTime" type="datetime" placeholder="指定时间"
											value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
											default-time="20:30:00" size="medium"
											style="width:50%; margin-left: 50px;"></el-date-picker>
									</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row v-if="formData.isSeat != 1" :gutter="30">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].isEditStore`">
									<span slot="label">
										B类售票权限:
									</span>
									<el-checkbox v-model="item.isEditStore" :true-label="1"
										:false-label="0">允许B类用户在演出通过审核后修改本场次票品库存</el-checkbox>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- <div class="page-group-title">
							<span>售票方式</span>
							<el-popover
								placement="right"
								width="400"
								trigger="hover">
								<el-table :data="item.propertyData" size="mini">
									<el-table-column prop="name" label="类别"></el-table-column>
									<el-table-column prop="value" label="票品"></el-table-column>
								</el-table>
								<el-button size="mini" slot="reference">查看票品</el-button>
							</el-popover>
						</div>
						<ticket-type v-if="formData.sessions[index]" :index="index"
							:formData.sync="formData.sessions[index]"></ticket-type> -->

						<div class="page-group-title">
							<span>观演人证件类型限制</span>
							<div class="MT10">
								<small class="color-warning">只有要求票品绑定观演人时，这里的设置才生效。</small>
							</div>
						</div>
						<real-name v-if="formData.sessions[index]" :index="index"
							:formData.sync="formData.sessions[index]"></real-name>
						<div class="page-group-title"><span>票夹展示票码逻辑</span></div>
						<el-form-item :prop="`sessions[${index}].isShowCode`" label="">
							<el-radio-group v-model="item.isShowCode" size="medium">
								<el-radio :label="2">强制展示：票夹中的票直接看码</el-radio>
								<el-radio :label="1">有限展示：观演人才能看码</el-radio>
								<!-- <el-radio :label="0">强制关闭：仅提示用户携带身份证件入场</el-radio> -->
							</el-radio-group>
						</el-form-item>
						<div class="page-group-title">
							<span>人证合一</span>
							<div class="MT10">
								<small
									class="color-warning">注意：若公安有明确要求演出需要人证合一、严格记录每一位入场人员信息，可开启此功能。开启后实名制演出，会严格执行人脸验证策略；<br>非实名制演出，专业版核销时会要求记录入场用户身份信息。</small>
							</div>
						</div>
						<el-form-item :prop="`sessions[${index}].faceVerify`" label="">
							<el-radio-group v-model="item.faceVerify" size="medium">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
						</el-form-item>

						<!-- <div class="page-group-title">
							<span>下单人实名认证</span>
						</div>
						<real-name-buyer class="MT20" v-if="formData.sessions[index]" :index="index"
							:formData.sync="formData.sessions[index]"></real-name-buyer> -->

						<div class="page-group-title">
							<span>场次限购</span>
							<div class="MT10">
								<small class="color-warning">对同一场次限制最多允许购买的票数（不限票品总类，包括免费票），0为不限购</small>
							</div>
						</div>

						<el-row :gutter="30">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].accountLimitBuyNum`"
									:rules="[{required: true, message: `请填写场次${index+1}的账号限制数量`}]">
									<span slot="label">账号限制: </span>
									<el-input-number style="width:100%" v-model="item.accountLimitBuyNum" :precision="0"
										controls-position="right" :min="0" :max="99999999" size="medium"
										placeholder="请填写账号限制"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item :prop="`sessions[${index}].certificateLimitBuyNum`" :rules="[{required: true, message: `请填写场次${index+1}的证件号限制数量`}]">
                                    <span slot="label">证件号限制:</span>
                                    <el-input-number style="width:100%"  v-model="item.certificateLimitBuyNum" :precision="0" 	controls-position="right" :min="0" :max="99999999" size="medium"></el-input-number>
                                </el-form-item>
                            </el-col>
						</el-row>

						<!-- <div class="page-group-title"><span>其他下单验证</span></div>
                        <el-row :gutter="30">
                            <el-col :xs="24" :xl="16">
                                <el-form-item :prop="`sessions[${index}].validateType`">
                                    <el-radio-group v-model="item.validateType" size="medium">
                                        <el-radio :label="0">不开启验证</el-radio>
                                        <el-radio :label="1">图形验证</el-radio>
                                        <el-radio :label="2">腾讯云验证</el-radio>
                                        <el-radio :label="3">Token验证</el-radio>
                                        <el-radio :label="4">腾讯云验证+Token验证</el-radio>
                                    </el-radio-group>
                                </el-form-item>        
                            </el-col>
                        </el-row>    -->

						<!-- <div class="page-group-title"><span>推广至外部销售渠道</span></div>
						<el-row :gutter="30">
							<el-col :xs="24" :xl="16">
								<el-form-item :prop="`sessions[${index}].thirdPartners`">
									<el-checkbox-group v-model="item.thirdPartners" size="medium">
										<el-checkbox v-for="(v,i) in thirdAccount" :key="i"
											:label="v.source">{{v.thirdName}}</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
						</el-row> -->

						<div class="page-group-title"><span>预估抢票力度</span></div>
						<el-form-item :prop="`sessions[${index}].setHotLevel`">
							<el-slider v-model="item.setHotLevel" :step="1" :max="3" :format-tooltip="formatTooltip"
								show-stops></el-slider>
							<div>
								<!-- 热度等级{{item.setHotLevel}}: -->
								<span v-if="item.setHotLevel == 0">大于1分钟抢光</span>
								<span v-else-if="item.setHotLevel == 1">30秒到1分钟内抢光</span>
								<span v-else-if="item.setHotLevel == 2">5秒到30秒抢光</span>
								<span v-else-if="item.setHotLevel == 3">5秒内抢光</span>
							</div>
							<small class="color-danger">
								注意：系统会自动计算预估抢票力度等级，但等级仍然可以人为调整，如果人为调整了预估抢票力度，系统会以人为设置的结果为准。
							</small>
						</el-form-item>
						<div class="page-group-title"><span>核销前变更观演人</span></div>
						<el-form-item :prop="`sessions[${index}].bindMore`" label="">
							<el-radio-group v-model="item.bindMore" size="medium">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-row :gutter="30" v-if="item.bindMore == 1">
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].bindStartTime`"
									:rules="[{required: true, message: `请选择场次${index+1}的开启时间`}]">
									<span slot="label">
										开启时间:
									</span>
									<el-date-picker v-model="item.bindStartTime" type="datetime" placeholder="开启时间"
										value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
										default-time="20:30:00" size="medium"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].bindEndTime`"
									:rules="[{required: true, message: `请选择场次${index+1}的截止时间`}]">
									<span slot="label">
										截止时间:
										<!-- <small @click="updateBindendtime(index)"><i class="color-blue hand">（设为场次开演时间）</i></small> -->
										<el-button size="mini" type="text" @click="updateBindendtime(index)">
											（设为场次开演时间）
										</el-button>
									</span>
									<el-date-picker v-model="item.bindEndTime" type="datetime" placeholder="截止时间"
										value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
										default-time="22:00:00" size="medium"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12" :xl="8">
								<el-form-item :prop="`sessions[${index}].bindNumber`"
									:rules="[{required: true, message: `请选择场次${index+1}的额外变更次数`}]">
									<span slot="label">
										额外变更次数:
										<small><i class="color-danger">（第1次绑定观演人后，还可以额外绑定观演人的次数 ）</i></small>
									</span>
									<el-input-number v-model="item.bindNumber" :precision="0" controls-position="right"
										:min="1" :max="100" size="medium" placeholder="请填写额外变更次数"></el-input-number>
								</el-form-item>
							</el-col>

						</el-row>
						<!-- <template v-if="formData.isSeat != 1" >
							<div class="page-group-title">							
								<span>预授权购票</span>
								<div class="MT10">
									<small
										class="color-warning">支持提前冻结用户支付宝或者微信的资金，成功抢到票以后再扣款，（注意：价格为0的免费票不支持开启预授权 ）</small>
								</div>
							</div>
							<el-form-item :prop="`sessions[${index}].isPreAuth`" label="">
								<el-radio-group v-model="item.isPreAuth" size="medium">
									<el-radio :label="1">开启</el-radio>
									<el-radio :label="0">关闭</el-radio>
								</el-radio-group>
							</el-form-item>
						</template> -->
						<div class="page-group-title"><span>闸机人脸验证</span></div>
						<el-form-item :prop="`sessions[${index}].gateFaceVerify`" label="">
							<el-radio-group v-model="item.gateFaceVerify" size="medium">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
						</el-form-item>

					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="!formData.haveEditAudit" name="-1">
					<span slot="label" class="color-danger"><i class="el-icon-plus"></i> 添加场次</span>
				</el-tab-pane>
			</el-tabs>
			<el-row :gutter="40" class="MT20" type="flex">
				<el-col>
					<el-button icon="el-icon-plus" type="primary" plain @click="dialogVisible = true"
						style="width:100%">添加场次</el-button>
				</el-col>
				<!-- <el-col v-if="$utils.have('/activity/cancelSession') && tabName != '-1' && formData.sessions[tabName].canCancel == 1" >
                    <el-button style="width:100%" icon="el-icon-remove-outline" @click="cancelSessionVisible = true">取消当前场次</el-button>
                </el-col> -->
			</el-row>
		</el-form>
		<el-divider></el-divider>
		<el-alert v-if="formMessage" type="error" :closable="false" title="提示" class="formMessage">
			<div v-html="formMessage"></div>
		</el-alert>
		<div>
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/activity/saveSessions')" type="primary" @click="onSubmit"
				:loading="btnLoading" :disabled="formData && formData.haveEditAudit">确认提交</el-button>
		</div>


		<!-- 新增场次 -->
		<el-dialog title="新增场次" :visible.sync="dialogVisible" width="500px" center>
			<div class="dialog-content">
				<el-form :model="copyInfo" ref="copyInfo">
					<el-form-item prop="name" label="场次名称:" :rules="[{required: true, message: '请输入场次名称'}]">
						<el-input v-model="copyInfo.name" placeholder="请输入场次名称" size="medium"></el-input>
					</el-form-item>
					<el-form-item prop="index" label="快捷复制:" required>
						<el-select v-model="copyInfo.index">
							<el-option :value="-1" label="不从其他场次复制信息"></el-option>
							<template v-if="formData">
								<el-option v-for="(item,index) in formData.sessions" :key="index" :value="index"
									:label="item.name"></el-option>
							</template>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addSessions">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 取消场次 -->
		<el-dialog :title="`取消${formData.sessions[tabName].name}`" :visible.sync="cancelSessionVisible" width="500px"
			center>
			<div class="dialog-content">
				<el-input type="textarea" :rows="4" v-model="cancelSessionRemark" placeholder="请输入备注" size="medium"
					maxlength="100" show-word-limit></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="cancelSessionVisible = false">关闭</el-button> -->
				<el-button type="primary" @click="cancelSession" :loading="cancelSessionBtnloading">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 新建艺人 -->
		<artist-add ref="artistAdd" @onUpdate="updateArtistList"></artist-add>
	</div>
</template>

<script>
	import Tab from '../components/tab';
	import TicketType from './components/ticket-type';
	import RealName from './components/real-name';
	import RealNameBuyer from './components/real-name-buyer';
	import {
		fetchUser,
		fetchThirdAccount
	} from '@/assets/js/commonApi';
	import ArtistAdd from '@/components/ArtistAdd';


	const defaultData = {
		accountLimitBuyNum: 0,
		buyType: 3,
		certificateLimitBuyNum:0,
		
		endTime: '',
		startTime: '',
		mailInstruction: '免邮/采用到付收费',
		name: '',
		performerIds: [],
		pickupAddress: '',
		pickupInstruction: '上门自取时,请提供二维码,手机号,身份证原件(如代领还需代领人身份证原件)',
		pickupLatitude: '',
		pickupLongitude: '',
		pickupTimes: [],
		realName: 0,
		realNameValidChannels: [1, 2, 3, 4],
		realNameValidType: 1,
		squadStatus: 1,
		isDisplay: 1,
		//thirdPartners: ['baoma'],
		ticketType: 1,
		validateType: 0,
		status: 1,
		canCancel: 0,
		setHotLevel: 0,
		faceVerify: 0,
		lineupNature: 1,
		guests: [],
		gateFaceVerify: 1,
		isShowCode: 1,
		isEditStore: 1,
		setTime: false,
		performers: [],
		artistList: [],
		//isPreAuth:0,
		commonPerformerDocumentType: ['1', '2', '3', '4', '5', '6'],
		seatShowTime: '',
		durationText: '',

		isSyncPerformers: 0,
		
	}

	export default {
		props: {
			id: {
				type: [Number, String],
				default: ""
			}
		},
		components: {
			Tab,
			TicketType,
			RealName,
			RealNameBuyer,
			ArtistAdd
		},
		data() {
			return {
				formData: {
					sessions: [{
						...defaultData
					}]
				},
				dataLoading: false,
				btnLoading: false,
				userLoading: false,
				sessionsIndex: 0, // 当前场次序列号
				tabName: "0",
				formMessage: '',
				dialogVisible: false,
				copyInfo: {
					index: -1,
					name: ''
				},
				redirect: this.$route.query.redirect,
				cancelSessionVisible: false,
				cancelSessionRemark: "",
				cancelSessionBtnloading: false,
				thirdAccount: [],
				artistType: 1,
				currentArtist: null,
			}
		},
		created() {
			this.getThirdAccount();
			if (this.id) {
				this.getDataDetail();
			}
		},
		methods: {
			handleCommand(command) {
				this.tabName = command.toString()
			},
			//获取第三方平台
			getThirdAccount() {
				fetchThirdAccount({
						isThird: 1
					})
					.then((res) => {
						const {
							state,
							result
						} = res.data;
						if (state == 1 && result) {
							this.thirdAccount = result.thirdAccounts || [];
						} else {
							// this.$message.error(msg || "请求失败");
						}
					})
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/sessions",
						params: {
							activityId: parseInt(this.id)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {

							let _formData = {
								...result,
							}
							_formData.sessions.map(item => {
								// item.datetimerange = item.startTime ? [item.startTime,item.endTime] : [];
								// item.performerIds = item.performers ? item.performers.map(v => {
								// 	return v.id
								// }) : [];
								item.performers = item.performers || [];
								item.artistList = item.performers ? [...item.performers] : [];
								// item.thirdPartners = item.thirdPartners || [];
								item.guests = item.guests || [];
								item.guestsList = item.guests ? [...item.guests] : [];
								item.pickupTimes = item.pickupTimes || [];
								item.realName = item.realName || 0;
								item.realNameValidChannels = item.realNameValidChannels || [];
								item.activityId = this.id;

								item.performers ? item.performers.map(items => {
									if (items.startTime && items.endTime) {
										this.$set(items, 'datetimerangeUser', [items.startTime, items
											.endTime
										]);
									}
								}) : "";
								
								if (item.performers && item.performers.length === 1) {
								    item.lineupNature = 1;
								}

								if (item.hotLevel == 0) {
									item.setHotLevel = 0
								}
								if (item.hotLevel == 1) {
									item.setHotLevel = 1
								}
								if (item.hotLevel == 4) {
									item.setHotLevel = 2
								}
								if (item.hotLevel == 7) {
									item.setHotLevel = 3
								}
								item.setTime = false
								
								item.durationText = '' //跨天的提示文字
								item.sessionNameMark = '' //场次名称没有按开演时间规范, 请注意检
								item.bindMore = item.bindNumber == 0 ? 0 : 1;
								item.bindEndTime = item.bindEndTime ? item.bindEndTime : item
									.startTime //截止时间是演出开始时间
								var now = this.$utils.formatDate((new Date().getTime()),
									'yyyy-MM-dd 00:00:00');
								item.bindStartTime = item.bindStartTime ? item.bindStartTime : now
								item.isDelayOriginal = item.isDelay
								item.commonPerformerDocumentType = item.commonPerformerDocumentType ? item.commonPerformerDocumentType.split(',') : []
								item.seatShowTime = item.seatShowTime ? item.seatShowTime : ''
								item.showSeat = item.seatShowTime ? 2 : 1

								item.isSyncPerformers = 0
							})
							
							//判断场次名称
							_formData.sessions.map(item => {
								if( item.startTime && item.endTime ){
									var startTime = new Date(item.startTime);
									var endTime = new Date(item.endTime);
									var duration = endTime.getTime() - startTime.getTime();
									var durationText = ''
									
									const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
									const weekdaysText = '周' + weekdays[startTime.getDay()]
													  
									var newActivityName = item.startTime.split(' ')[0] + weekdaysText + item.startTime.split(' ')[1].substring(0, 5);
									
									if( item.name.replace(/\s+/g, '')!= newActivityName ){
										item.sessionNameMark = `<span style="color:#F56C6C">场次名称没有按开演时间规范, 请注意检查</span>`
									}
									
									// 计算各个单位
									const days = Math.floor(duration / (1000 * 60 * 60 * 24))
									const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
									const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60))
									
									if (days >= 1) {
										durationText = `场次持续时间：${days}天 ${hours}小时 ${minutes}分钟 
				<span style="color: #F56C6C; margin-left:30px">时间已跨天, 请注意检查！</span>`
									} else {
										durationText = '场次持续时间：' + `${hours}小时 ${minutes}分钟`
									}				
									item.durationText = durationText			
								}
							})							
							
							this.formData = _formData;

						} else {
							this.$message.error(msg || "获取演出场次失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取演出场次失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//按开演时间更新场次名称
			updateName(index){
				if (this.formData.sessions[index].startTime ) {
					var startTime = new Date(this.formData.sessions[index].startTime);
					const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
					const weekdaysText = '周' + weekdays[startTime.getDay()]
									  
					var newActivityName = 	this.formData.sessions[index].startTime.split(' ')[0] + ' '  + weekdaysText + ' ' + this.formData.sessions[index].startTime.split(' ')[1].substring(0, 5)
					
					this.formData.sessions[index].name = newActivityName
					this.formData.sessions[index].sessionNameMark = ''
				}
			},
			nameChange(index){				
				if( this.formData.sessions[index].startTime && this.formData.sessions[index].endTime ){
					var startTime = new Date(this.formData.sessions[index].startTime);					
					const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
					const weekdaysText = '周' + weekdays[startTime.getDay()]									  
					var newActivityName = this.formData.sessions[index].startTime.split(' ')[0] + weekdaysText + this.formData.sessions[index].startTime.split(' ')[1].substring(0, 5);	
					if( this.formData.sessions[index].name.replace(/\s+/g, '') != newActivityName ){
						this.formData.sessions[index].sessionNameMark = `<span style="color:#F56C6C">场次名称没有按开演时间规范, 请注意检查</span>`
					}						
				}
			},
			//开演时间更新一系列提示6669007110
			timeChange(index) {
				if (this.formData.sessions[index].startTime && this.formData.sessions[index].endTime ) {
					var startTime = new Date(this.formData.sessions[index].startTime);
					var endTime = new Date(this.formData.sessions[index].endTime);
					var duration = endTime.getTime() - startTime.getTime();
					var durationText = ''
					
					// 计算各个单位
					const days = Math.floor(duration / (1000 * 60 * 60 * 24))
					const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
					const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60))
					
					if (days >= 1) {
						durationText = `场次持续时间：${days}天 ${hours}小时 ${minutes}分钟 
              <span style="color: #F56C6C; margin-left:30px">时间已跨天, 请注意检查！</span>`
					} else {
						durationText = '场次持续时间：' + `${hours}小时 ${minutes}分钟`
					}
					this.formData.sessions[index].durationText = durationText
				}

			},
			updateBindendtime(index) {
				
				if( this.formData.sessions[index].startTime == ''){
					return this.$message.error("请填写演出开始时间");
				} else {
					var startTime = this.formData.sessions[index].startTime
					this.formData.sessions[index].bindEndTime = startTime
				}
			},
			updateUser(index) {

				this.formData.sessions[index].performers.map(items => {
					if (items.startTime && items.endTime) {
						this.$set(items, 'datetimerangeUser', [items.startTime, items.endTime]);
					}

				})
				this.formData.sessions[index].performersTime = this.formData.sessions[index].performers;
				// 艺人只有一个时，默认为单人专场
				if (this.formData.sessions[index].performers && this.formData.sessions[index].performers.length == 1) {
					this.formData.sessions[index].lineupNature = 1;
				}
				if( this.formData.sessions[index].isSyncPerformers == 1){
					this.syncPerformers(1,index);
				}
			},
			timeshow(index) {
				this.formData.sessions[index].setTime = true
				this.updateUser(index);
			},
			clearTime(index) {
				this.formData.sessions[index].performersTime.forEach(item => {
					item.datetimerangeUser = []
				})
				this.formData.sessions[index].setTime = false
			},
			changeLineupNature(index,value){
				if(this.formData.sessions[index].performers && this.formData.sessions[index].performers.length ==1 && value == 2 ){
					this.formData.sessions[index].lineupNature = 1
					return this.$message.error("单个艺人不可选择多人拼盘");					
				}
			},
			//艺人搜索
			onFocus(index) {
				this.sessionsIndex = index;
			},
			searchArtist(query) {
				this.searchUser(query, 2, 'artistList');
			},
			searchGuests(query) {
				this.searchUser(query, 2, 'guestsList');
			},
			// 搜索用户
			async searchUser(query, userType, name) {
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: userType,
					}).finally(() => {
						this.userLoading = false;
					});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this.formData.sessions[this.sessionsIndex][name] = result;

						if (name == 'artistList') {
							const arry = [...this.formData.sessions[this.sessionsIndex].performers];
							result.map(v => {
								if (!arry.find(item => item.id == v.id)) {
									arry.push(v);
								}
							})
							this.formData.sessions[this.sessionsIndex].artistList = [...arry];
						}
						if (name == 'guestsList') {
							const arry2 = [...this.formData.sessions[this.sessionsIndex].guests];
							result.map(v => {
								if (!arry2.find(item => item.id == v.id)) {
									arry2.push(v);
								}
							})
							this.formData.sessions[this.sessionsIndex].guestsList = [...arry2];
						}

					}
				}
			},
			//艺人新增
			addArtist(index, artistType, data) {
				let _data = null;
				if( data ){
					_data = {
						...data,
						styles: data.styles ?  data.styles.split(',')  || [] : [],
						tags: data.tags ?  data.tags.split(',')  || [] : [],
					};
					this.currentArtist = _data;
				}
				this.sessionsIndex = index;
				this.artistType = artistType;
				this.$refs.artistAdd.show(_data);
			},
			//创建艺人更新
			updateArtistList(data) {
				if (this.artistType === 1) {
					this.formData.sessions[this.sessionsIndex].artistList.push(data);
					this.formData.sessions[this.sessionsIndex].performers.push(data);
					//删除已绑定的艺人
					if(  this.currentArtist ){
						this.formData.sessions[this.sessionsIndex].customPerformers = this.formData.sessions[this.sessionsIndex].customPerformers.filter(v => v.name != this.currentArtist.name);
					}
				} else {
					this.formData.sessions[this.sessionsIndex].guestsList.push(data);
					this.formData.sessions[this.sessionsIndex].guests.push(data);
					//删除已绑定的艺人
					if(  this.currentArtist ){
						this.formData.sessions[this.sessionsIndex].customGuests = this.formData.sessions[this.sessionsIndex].customGuests.filter(v => v.name != this.currentArtist.name);
					}
				}
			},
			//删除场次
			removeSessions(targetName) {
				this.$confirm('确定要删除当前场次吗?', '提示', {
					type: 'warning',
					center: true,
					closeOnClickModal: false
				}).then(() => {

					let tabs = this.formData.sessions;
					let activeName = this.tabName;

					if (activeName === targetName) {
						tabs.forEach((tab, index) => {
							if (index == targetName) {
								let nextTab = tabs[index + 1] || tabs[index - 1];
								if (nextTab) {
									activeName = tabs.findIndex(v => v == nextTab);
								}
							}
						});
					}

					this.formData.sessions = tabs.filter((v, i) => i != targetName);
					this.tabName = activeName >= this.formData.sessions.length ? this.formData.sessions.length -
						1 : activeName;
					this.tabName = this.tabName.toString();
				})
			},
			//添加场次
			addSessions() {
				this.$refs["copyInfo"].validate((valid) => {
					if (valid) {
						if (this.formData.sessions.find(v => v.name == this.copyInfo.name)) {
							return this.$message.error("场次名称已存在,不能重复!");
						}

						const len = this.formData.sessions.length;
						const _os = this.formData.sessions[this.copyInfo.index] || {
							...defaultData
						};

						this.$set(this.formData.sessions, len, {
							..._os,
							id: "",
							activityId: this.id,
							name: this.copyInfo.name,
							status: 1,
							canCancel: 0
						});

						this.tabName = len.toString();

						this.copyInfo = {
							name: '',
							index: -1
						};
						this.$refs.copyInfo.resetFields();
						this.dialogVisible = false;
						document.documentElement.scrollTop = document.body.scrollTop = 0;
					}
				})
			},

			//表单提交
			onSubmit() {
				this.$refs["formData"].validate((valid, label) => {
					if (valid) {
						this.formMessage = "";

						const _sessions = JSON.parse(JSON.stringify(this.formData.sessions));

						try {
							_sessions.forEach(item => {
								var newUser = []
								item.performers.forEach(v => {
									newUser.push({
										id: v.id,
										startTime: v.datetimerangeUser && v
											.datetimerangeUser != '' ? v.datetimerangeUser[
												0] : '',
										endTime: v.datetimerangeUser && v
											.datetimerangeUser != '' ? v.datetimerangeUser[
												1] : '',
										startUnix: v.datetimerangeUser && v
											.datetimerangeUser != '' ? new Date(v
												.datetimerangeUser[0].replace(/-/g, "/"))
											.getTime() : '',
										endUnix: v.datetimerangeUser && v
											.datetimerangeUser != '' ? new Date(v
												.datetimerangeUser[1].replace(/-/g, "/"))
											.getTime() : '',
										sort: v.sort || 1000,
									})
								})
								var timeSelectd = false
								var timeSelectdNo = 0
								for (var i1 = 0; i1 < newUser.length; i1++) {
									var v1 = newUser[i1]
									if (timeSelectd == false && (v1.startTime != "" || v1.endTime != "")) {
										timeSelectd = true
									}
									if (timeSelectd && (v1.startTime == "" || v1.endTime == "")) {
										timeSelectdNo += 1
									}
								}
								if (timeSelectdNo > 0) {
									//this.$message.error("还有"+timeSelectdNo+"个艺人出场时间段未配置，请补全后提交");
									throw new Error("还有" + timeSelectdNo + "个艺人出场时间段未配置，请补全后提交");
									return false;
								}
								for (i1 = 0; i1 < newUser.length; i1++) {
									for (var i2 = 0; i2 < newUser.length; i2++) {
										if (i1 == i2) {
											continue;
										}
										v1 = newUser[i1]
										var v2 = newUser[i2]
										if (v1.startUnix != '' && v1.endUnix != '' && v2.startUnix != '' &&
											v2.endUnix != '') {
											if ((v1.startUnix >= v2.startUnix && v1.endUnix >= v2
													.endUnix && v1.startUnix <= v2.endUnix) ||
												(v1.startUnix <= v2.startUnix && v1.endUnix <= v2
													.endUnix && v1.endUnix >= v2.startUnix) ||
												(v1.startUnix <= v2.startUnix && v1.endUnix >= v2.endUnix)
											) {
												//this.$message.error(item.sessionName+'的艺人演出时间段和其他艺人重叠，请重新选择');
												//this.$message.error("当前艺人演出时间段和其他艺人重叠，请重新选择");
												throw new Error('艺人演出时间段和其他艺人重叠，请重新选择');
												return false;
											}
										}

									}
								}

								item.performers = newUser;

								item.commonPerformerDocumentType = item.commonPerformerDocumentType
									.toString();

								item.guests.map((g, i) => g.sort = g.sort || 1000);
							})
						} catch (err) {
							return this.$message.error(err.message);
						}

						_sessions.map((v, i) => {
							if (v.setHotLevel == 2) {
								this.$set(_sessions[i], "setHotLevel", 4);
							}
							if (v.setHotLevel == 3) {
								this.$set(_sessions[i], "setHotLevel", 7);
							}
							if (v.bindMore == 0) {
								this.$set(_sessions[i], "bindStartTime", '');
								this.$set(_sessions[i], "bindEndTime", '');
								this.$set(_sessions[i], "bindNumber", 0);
							}
							if (v.showSeat == 1) {
								this.$set(_sessions[i], "seatShowTime", '');
							}
						})

						const _statusFlag = _sessions.filter(v => v.isDisplay == 1);
						if (_statusFlag.length < 1) {
							return this.$message.error("请至少保留一个场次正常启用");
						}

						_sessions.map((v, i) => {
							if (this.$utils.compareDate(v.startTime, v.endTime)) {
								this.formMessage += `<div>场次${i+1}: 演出开始时间必须小于演出结束时间</div>`;
							}
							if (this.$utils.compareDate(v.bindStartTime, v.bindEndTime)) {
								this.formMessage += `<div>场次${i+1}: 核销前变更观演人开始时间必须小于结束时间</div>`;
							}
							if (new Date(v.startTime.replace(/-/g, "/")).getTime() < new Date()
								.getTime() && v.isDelayOriginal == 1 && v.isDelay == 0) {
								this.formMessage += `<div>场次${i+1}: 场次开演时间应该大于当前时间，请酌情修改</div>`;
							}
							if (v.showSeat == 2 && v.seatShowTime == '') {
								this.formMessage += `<div>场次${i+1}: 座位号展示逻辑指定时间不能为空</div>`;
							}
							

						})

						if (this.formMessage && this.formMessage != '') return;

						this.btnLoading = true;


						this.$request({
								url: "/activity/saveSessions",
								method: "POST",
								data: _sessions,
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg,
									result
								} = res.data;
								if (state && state == 1) {
									let _msg = ""
									if (_sessions.find(v => !v.id)) {
										_msg = "请及时为新增的场次添加票品，否则乐迷购票端可能会出现错误";
									}
									if (result.content) {
										this.$confirm(
											`此次提交修改了：${result.content} 。如需告知用户，请到【变动通知】页面进行操作。<br>${_msg}`,
											'提示', {
												// type: 'success',
												// center: true,
												confirmButtonText: '查看变动通知',
												cancelButtonText: '暂不处理',
												closeOnClickModal: false,
												dangerouslyUseHTMLString: true,
											}).then(() => {
											this.$router.push(
												`/activityManage/activity/edit/changeNotice/${this.id}`
											)
										}).catch(() => {

										})
									} else {
										this.$confirm(`操作成功！<br>${_msg}`, '提示', {
											// type: 'success',
											// center: true,
											confirmButtonText: '返回上一页',
											cancelButtonText: '留在当前页面',
											closeOnClickModal: false,
											dangerouslyUseHTMLString: true,
										}).then(() => {
											this.goBack();
										}).catch(() => {
											this.getDataDetail();
										})
									}



								} else {
									return this.$message.error(msg || "操作失败");
								}
							})
							.finally(() => {
								this.btnLoading = false;
							});
					} else {
						let keys = Object.keys(label)
						this.formMessage = label[keys[0]][0].message;
					}
				});
			},

			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			//取消场次
			cancelSession() {
				this.cancelSessionBtnloading = true;
				this.$request({
						url: "/activity/cancelSession",
						method: "POST",
						params: {
							activityId: parseInt(this.id),
							remark: this.cancelSessionRemark,
							sessionId: this.formData.sessions[this.tabName].id
						},
					})
					.then((res) => {
						//处理成功回调
						const {
							state,
							msg,
							result
						} = res.data;
						if (state && state == 1) {
							this.cancelSessionVisible = false;
							if (result.content) {
								this.$confirm('该场次已经产生了通票订单，因此取消场次视为重要变动。如需告知用户，请到【变动通知】页面进行操作', '提示', {
									// type: 'success',
									center: true,
									confirmButtonText: '查看变动通知',
									cancelButtonText: '暂不处理',
									closeOnClickModal: false
								}).then(() => {
									this.$router.push(`/activityManage/activity/edit/changeNotice/${this.id}`)
								}).catch(() => {

								})
							} else {
								this.$message.success("操作成功");
							}
							this.getDataDetail();
							this.cancelSessionRemark = "";
						} else {
							return this.$message.error(msg || "操作失败");
						}
					}).finally(() => {
						this.cancelSessionBtnloading = true;
					})
			},
			beforeLeave(activeName) {
				if (activeName == "-1") {
					this.dialogVisible = true
					return false
				}
			},
			formatTooltip(val) {
				if (val == 0) {
					return "大于1分钟抢光"
				} else if (val != 0 && val <= 3) {
					return "30秒到1分钟内抢光"
				} else if (val >= 4 && val <= 6) {
					return "5秒到30秒抢光"
				} else {
					return "5秒内抢光"
				}
			},
			//删除艺人
			removePerformer(index,i){
				this.formData.sessions[index].customPerformers.splice(i,1)
			},
			
			//删除嘉宾
			removeGuest(index,i){
				this.formData.sessions[index].customGuests.splice(i,1)
			},
			//同步艺人
			syncPerformers(e,index){
				if( e == 1){
					const _sessions = this.formData.sessions[index];
					this.formData.sessions.map((item,i) => {
						if(index != i){
							item.isSyncPerformers = 0;
							item.artistList = _sessions.artistList;
							item.performers = _sessions.performers;
						}
					})
				}
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.el-tabs {
		margin-top: 10px;

		::v-deep .el-tabs__header {
			margin-bottom: 0;
		}

		.sessions-card {
			border-radius: 0;
			border-top: 0;
		}

	}

	.formMessage {
		margin-bottom: 20px;
	}

	.hand {
		cursor: pointer;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}
</style>